import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";

export const NoData = ({ title, message }) => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center text-center">
      <div className="mb-6 animate-bounce rounded-full bg-gray-100 p-6 shadow-md">
        <FontAwesomeIcon icon={faRefresh} size="lg" className="h-16 w-16 text-gray-400" />
      </div>
      <h2 className={`text-textPrimary text-2xl font-semibold`}>{title}</h2>
      <p className={`text-textPrimary mt-2`}>{message}</p>
    </div>
  );
};
